import { apiClient } from "./client";

export interface LocalGatewayInstallerArtifactMetadata {
  packageFormat: "msi" | "exe" | "pkg" | "deb" | "rpm";
  fileName: string;
  downloadUrl: string;
  sha256: string;
  sizeBytes: number;
}

export interface LocalGatewayInstallerTargetMetadata {
  target: "windows-amd64" | "windows-arm64" | "darwin-arm64" | "linux-amd64" | "linux-arm64";
  version: string;
  nativeSigningState: "signed" | "development_unsigned";
  notarizationState: "accepted" | "not_applicable" | "development_unverified";
  artifacts: LocalGatewayInstallerArtifactMetadata[];
}

export type LocalGatewayInstallerMetadataFailureClass =
  | "unconfigured"
  | "configuration_invalid"
  | "viewer_authorization_unavailable"
  | "dns_or_tls"
  | "timeout"
  | "http_status"
  | "redirect"
  | "oversize"
  | "invalid_json"
  | "schema_invalid"
  | "signature_invalid"
  | "environment_mismatch"
  | "generation_invalid"
  | "digest_mismatch"
  | "origin_binding_mismatch";

export type LocalGatewayInstallerMetadataResponse =
  | {
      state: "available";
      releaseId: string;
      version: string;
      environment: "development" | "staging" | "production";
      generation: number;
      publishedAt: string;
      targets: LocalGatewayInstallerTargetMetadata[];
    }
  | { state: "unavailable"; failureClass: LocalGatewayInstallerMetadataFailureClass | "bff_unavailable" };

export async function getLocalGatewayInstallerMetadata() {
  return await apiClient<LocalGatewayInstallerMetadataResponse>(
    "/local-gateway-installer-downloads",
  );
}
